import React from 'react';
import PropTypes from 'prop-types';
import EditButton from '../../atoms/EditButton/EditButton';
import DeleteButton from '../../atoms/DeleteButton/DeleteButton';

const TableActions = ({
  onEdit,
  onDelete,
}) => (
  <>
    {onEdit && (
      <EditButton onInvoked={onEdit} />
    )}
    {onEdit && onDelete && (
      '|'
    )}
    {onDelete && (
      <DeleteButton onInvoked={onDelete} />
    )}
  </>
);

TableActions.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

TableActions.defaultProps = {
  onEdit: undefined,
  onDelete: undefined,
};

export default TableActions;
